<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 4C2 3.44772 2.44772 3 3 3H17C17.5523 3 18 3.44772 18 4C18 4.55228 17.5523 5 17 5H3C2.44772 5 2 4.55228 2 4Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 16C2 15.4477 2.44772 15 3 15H17C17.5523 15 18 15.4477 18 16C18 16.5523 17.5523 17 17 17H3C2.44772 17 2 16.5523 2 16Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 10C2 9.44772 2.44772 9 3 9H13C13.5523 9 14 9.44772 14 10C14 10.5523 13.5523 11 13 11H3C2.44772 11 2 10.5523 2 10Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconBars",

  props: {
    // цвет иконки
    color: {
      type: String,
      default() {
        return this.$vuetify.theme.textPrimary;
      }
    },
    // размер
    size: {
      type: String,
      default: "20"
    }
  }
};
</script>
